
import { ResourcesListContext } from "./resourcesList";
import { getDisplayName } from "../Utils/getDisplayName";

export default function withResourcesList(WrappedComponent) {
  const WithResourcesList = props => (
    <ResourcesListContext.Consumer>
      {({ resourcesListKey }) => (
        <WrappedComponent resourcesListKey={resourcesListKey} {...props} />
      )}
    </ResourcesListContext.Consumer>
  );

  WithResourcesList.displayName = `WithResourcesList(${getDisplayName(
    WrappedComponent
  )})`;

  return WithResourcesList;
}
